<template>
  <div class="flex-wrap justify-center" style="gap: .5rem">
    <template v-if="!isLoading">
      <template v-if="badges.length">
        <b-badge
          v-for="(item, index) in badges"
          :key="index"
          class="badge m-1"
          :class="`${getClass} ${item.class}`"
          :variant="variant"
          :pill="pill"
          :style="customColor(item)"
        >
          {{ text(item) }}
        </b-badge>
      </template>
    </template>
    <template v-else>
    <div v-if="Array.isArray(value)" class="d-flex flex-wrap" style="gap: .5rem">
      <b-skeleton v-for="item in 4" :key="item" width="80px"></b-skeleton>
    </div>
    <b-skeleton width="80px" v-else></b-skeleton>
    </template>
  </div>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'

export default {
  props: {
    value: {
      type: [String, Object, Boolean, Array],
      required: true
    },
    pill: {
      type: Boolean,
      default: true
    },
    variant: {
      type: String,
      default: 'secondary'
    },
    populate: {
      type: Boolean,
      default: false
    },
    populateEndpoint: {
      type: String,
      default: null
    },
    displayProp: {
      type: String,
      default: null
    },
    invertGreenAnRedColors: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getClass () {
      let classes = ''
      if (this.pill) {
        classes += 'px-2'
      }
      return classes
    }
  },
  data () {
    return {
      isLoading: false,
      badges: []
    }
  },
  methods: {
    text (item) {
      if (typeof item === 'boolean') {
        return item ? 'Si' : 'No'
      }
      return typeof item === 'string' ? item : item.name
    },
    customColor (item) {
      // Si el item tiene una propiedad color retornada desde el backend la usamos.
      if (item?.color) {
        return `background-color: ${item.color}`
      }
      // Si el item es un booleano le asignamos verde o rojo (o viceversa).
      if (item === true) {
        return `background-color: ${this.invertGreenAnRedColors ? 'red' : 'green'}`
      } else if (item === false) {
        return `background-color: ${this.invertGreenAnRedColors ? 'green' : 'red'}`
      }
      return ''
    }
  },
  async created () {
    try {
      this.isLoading = true
      if (this.populate) {
        if (Array.isArray(this.value)) {
          const items = []
          for (const item of this.value) {
            const res = await commonsApi.axiosGetWrapper(this.populateEndpoint + '/' + item)
            items.push({
              id: res.data._id,
              name: res.data[this.displayProp || 'name']
            })
          }
          this.badges = items
        } else {
          const res = await commonsApi.axiosGetWrapper(this.populateEndpoint + '/' + this.value)
          this.badge = {
            id: res.data._id,
            name: res.data[this.displayProp || 'name']
          }
        }
      } else {
        if (this.value || this.value.length) {
          this.badges = [this.value].flat()
        } else if (this.value === false) {
          this.badges = [this.value]
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>
<style>
.badge {
  padding: 5px 8px;
}

.document-status.color-2, .document-status:hover.color-2 {
  background-color: #007bff;
}

.document-status.color-3, .document-status:hover.color-3 {
  background-color: #97077D;
}

.document-status.color-4, .document-status:hover.color-4 {
  background-color: #6FB200;
}

.document-status.color-6, .document-status:hover.color-6 {
  background-color: #00872A;
}

.document-status.color-7, .document-status:hover.color-7 {
  background-color: rebeccapurple;
}

.document-status.color-9, .document-status:hover.color-9 {
  background-color: red;
}

.process-status.color-1, .process-status:hover.color-1, .parcelaria-status.color-1, .parcelaria-status:hover.color-1 {
  background-color: #007bff;
}

.process-status.color-5, .process-status:hover.color-5, .parcelaria-status.color-5, .parcelaria-status:hover.color-5 {
  background-color: #6FB200;
  color: black;
}

.process-status.color-3, .process-status:hover.color-3, .parcelaria-status.color-3, .parcelaria-status:hover.color-3 {
  background-color: #6FB200;
}

.process-status.color-6, .process-status:hover.color-6, .parcelaria-status.color-6, .parcelaria-status:hover.color-6 {
  background-color: cadetblue;
}

.process-status.color-7, .process-status:hover.color-7, .parcelaria-status.color-7, .parcelaria-status:hover.color-7 {
  background-color: green;
}

.process-status.color-8, .process-status:hover.color-8, .parcelaria-status.color-8, .parcelaria-status:hover.color-8 {
  background-color: #ABABD4;
}

.process-status.color-9, .process-status:hover.color-9, .parcelaria-status.color-9, .parcelaria-status:hover.color-9 {
  background-color: #5F1F7B;
}

.process-status.color-10, .process-status:hover.color-10, .parcelaria-status.color-10, .parcelaria-status:hover.color-10 {
  background-color: red;
}

.process-status.color-11, .process-status:hover.color-11, .parcelaria-status.color-11, .parcelaria-status:hover.color-11 {
  background-color: #97077D;
}

.process-status.color-12, .process-status:hover.color-12, .parcelaria-status.color-12, .parcelaria-status:hover.color-12 {
  background-color: teal;
}

.process-status.color-13, .process-status:hover.color-13, .parcelaria-status.color-13, .parcelaria-status:hover.color-13 {
  background-color: tomato;
}

.process-status.color-14, .process-status:hover.color-14, .parcelaria-status.color-14, .parcelaria-status:hover.color-14 {
  background-color: #132C7A;
}

.process-status.color-15, .process-status:hover.color-15, .parcelaria-status.color-1, .parcelaria-status:hover.color-1 {
  background-color: #00872A;
}

.process-status.color-16, .process-status:hover.color-16, .parcelaria-status.color-16, .parcelaria-status:hover.color-16 {
  background-color: #132C7A;
}

.process-status.color-9999, .process-status:hover.color-9999, .parcelaria-status.color-9999, .parcelaria-status:hover.color-9999 {
  background-color: orange;
}

.parcelaria-catastro-status.color-1, .parcelaria-catastro-status:hover.color-1 {
  background-color: #6FB200;
}

.parcelaria-catastro-status.color-2, .parcelaria-catastro-status:hover.color-2 {
  background-color: red;
}
</style>
